import React, { Component } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import strings from '../components/language/language';

const styles = {
  options: {
    display: 'flex',
    backgroundColor: 'red'
  },
  title: {
    margin: '10px 0'
  },
  price: {
    position: 'absolute',
    left: 490,
    color: '#70142C !important',
    display: 'inline-flex',
    fontSize: 16,
    fontFamily: 'Cabin'
  }
};

class ItemSelect extends Component {
  state = {
    value: 'small',
    chocolate: true,
    cream: false,
    cherries: false
  };

  handleChangeRadio = event => {
    this.setState({ value: event.target.value });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const { chocolate, cream, cherries } = this.state;
    const { classes } = this.props;
    return (
      <div>
        {/* choose size */}
        <Typography variant='h6' className={classes.title}>
          Choose Size
        </Typography>
        <FormControl component='fieldset'>
          <RadioGroup
            onChange={this.handleChangeRadio}
            value={this.state.value}
          >
            <FormControlLabel
              className='options'
              value='small'
              control={
                <Radio
                  labelStyle={{ color: '#70142C' }}
                  iconStyle={{ fill: '#70142C' }}
                  inputStyle={{ color: '#70142C' }}
                  style={{ color: '#70142C' }}
                />
              }
              label={
                <React.Fragment>
                  <div className='addon-name'>Small</div>
                  <div className={classes.price}>32{strings.currency}</div>
                </React.Fragment>
              }
            />
            <FormControlLabel
              className='options'
              value='meduim'
              control={
                <Radio
                  labelStyle={{ color: '#70142C' }}
                  iconStyle={{ fill: '#70142C' }}
                  inputStyle={{ color: '#70142C' }}
                  style={{ color: '#70142C' }}
                />
              }
              label={
                <React.Fragment>
                  <div className='addon-name'>Meduim</div>
                  <div className={classes.price}>11{strings.currency}</div>
                </React.Fragment>
              }
            />
            <FormControlLabel
              className='options'
              value='large'
              control={
                <Radio
                  labelStyle={{ color: '#70142C' }}
                  iconStyle={{ fill: '#70142C' }}
                  inputStyle={{ color: '#70142C' }}
                  style={{ color: '#70142C' }}
                />
              }
              label={
                <React.Fragment>
                  <div className='addon-name'>Large</div>
                  <div className={classes.price}>22{strings.currency}</div>
                </React.Fragment>
              }
            />
          </RadioGroup>
        </FormControl>
        {/* choose topping */}
        <Typography variant='h6' className={classes.title}>
          Choose Topping
        </Typography>
        <FormControl component='fieldset'>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={chocolate}
                  onChange={this.handleChange('chocolate')}
                  value='chocolate'
                  style={{ color: '#70142b' }}
                />
              }
              label='Chocolate'
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={cream}
                  onChange={this.handleChange('cream')}
                  value='cream'
                  style={{ color: '#70142b' }}
                />
              }
              label='Cream'
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={cherries}
                  onChange={this.handleChange('cherries')}
                  value='cherries'
                  style={{ color: '#70142b' }}
                />
              }
              label='Cherries'
            />
          </FormGroup>
        </FormControl>
      </div>
    );
  }
}

export default withStyles(styles)(ItemSelect);



// WEBPACK FOOTER //
// ./src/components/ItemSelect.js